export default "__VITE_ASSET__CXeTmyur__"